import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';

export default styled.div`
  font-size: 0.8rem;
  border-bottom: 1px solid ${lightGrey2Color};
  padding: 0.5rem;
  box-shadow: 0 3px 5px -6px black;
  position: relative;
`;
